import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

import easing from 'ui/styles/easing'

export default class Newsletter extends PureComponent {
 /*  state = {
    isScrolled: false,
    isMobile: false,
      isValid: false,
      emailValid: false,
      email: '',
      phoneValid: false,
      phone: '',
      nameValid: false,
      name: '',
      companyValid: false,
      company: '',
      commentValid: false,
      errorMsg: []
  } */

  constructor(props) {
    super(props)
    this.scrollRef = React.createRef()
    this.state = {
      isScrolled: false,
      isMobile: false,
        isValid: false,
        emailValid: false,
        email: '',
        phoneValid: false,
        phone: '',
        nameValid: false,
        name: '',
        companyValid: false,
        company: '',
        commentValid: false,
        errorMsg: [],
        bannedMail: ''
    }
  }

  formValidator = () => {
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/;
    console.log('form change has fired');
    let stateVar = this.state;
    let emailField = document.getElementById('email');
    let phoneField = document.getElementById('phone');
    let nameField = document.getElementById('fullname');
    let companyField = document.getElementById('field[18]');
    let commentField = document.getElementById('field[27]');
    let button =  document.getElementById('_form_33_submit');
    button.classList.add('disabled');
    let commentLastChar = commentField.value.charAt(commentField.value.length - 1);
    this.setState({ email: emailField.value, phone: phoneField.value, name: nameField.value, company: companyField.value });
    this.validatorChecker(stateVar, button);
    //Check if provided email is banned
    let bannedMails = ['drivem.my.id', 'vivaldigital.com', 'mdriveku.my.id', 'gdriveme.id', 'bozzcello.com', 'keyestate.ooo', 'microsoft.com'];
    if(bannedMails.some((item) => this.state.email.includes(item))){
      this.setState({bannedMail: true})
    }else {
      this.setState({bannedMail: false})
    }
    console.log(this.state.bannedMail);
    if (emailField.value.match(emailRegex) && this.state.bannedMail === false) {
      let msg = "Please input correct email address"
      this.setState({ emailValid: true })
      emailField.style.border = "none";
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
    } else {
      emailField.style.borderBottom = "thick solid red";
      let msg = "Please input correct email address"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] },  this.validatorChecker(stateVar, button))
      }
      this.setState({ emailValid: false}, this.validatorChecker(stateVar, button))
    }

    if (phoneField.value.match(phoneRegex)) {
      this.setState({ phoneValid: true },  this.validatorChecker(stateVar, button))
      phoneField.style.border = "none";
      let msg = "Please input a valid phone number"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
    } else {
      this.setState({ phoneValid: false},  this.validatorChecker(stateVar, button))
      phoneField.style.borderBottom = "thick solid red";
      let msg = "Please input a valid phone number"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] },  this.validatorChecker(stateVar, button))
      }
    }

    if (companyField.value.toLowerCase() !== nameField.value.toLowerCase()) {
      this.setState({ companyValid: true, nameValid: true },  this.validatorChecker(stateVar, button))
      companyField.style.border = "none";
      nameField.style.border = "none";
      let msg = "Full name and company name cannot be the same"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      this.nameFieldCheck(nameField,  this.validatorChecker(stateVar, button));
      this.companyFieldCheck(companyField,  this.validatorChecker(stateVar, button));
    } else {
      
      this.nameFieldCheck(nameField,  this.validatorChecker(stateVar, button));
      this.companyFieldCheck(companyField,  this.validatorChecker(stateVar, button));
      
      companyField.style.borderBottom = "thick solid red";
      nameField.style.borderBottom = "thick solid red";
      let msg = "Full name and company name cannot be the same"
      
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] },  this.validatorChecker(stateVar, button))
      }
      this.setState({companyValid: false, nameValid: false},  this.validatorChecker(stateVar, button))
    }





    if (commentLastChar !== '-') {     
      commentField.style.border = "none";
      let msg = "Inserted comment is incorrect"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      this.setState({commentValid: true}, this.validatorChecker(stateVar, button))
    } else {
      commentField.style.borderBottom = "thick solid red";
      let msg = "Inserted comment is incorrect"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] },  this.validatorChecker(stateVar, button))
      }
      this.setState({commentValid: false}, this.validatorChecker(stateVar, button))
    }
    }

  


  nameFieldCheck = (nameField) => {
    if (nameField.value !== "." && nameField.value !== "-") {
      this.setState({ nameValid: true })
      let msg = "Please input a valid name"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      nameField.style.border = "none";
    } else {
      this.setState({ nameValid: false})
      let msg = "Please input a valid name"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] })
      }
      nameField.style.borderBottom = "thick solid red";
    }
  }

  companyFieldCheck = (companyField) => {
    if (companyField.value !== "dol" && companyField.value !== "dol-sensors" && companyField.value !== "dol sensors" && !companyField.value.includes('@')) {
      let msg = "Invalid company name"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      companyField.style.borderBottom = "none"
      this.setState({companyValid: true})
    } else {
      this.setState({companyValid: false})
      let msg = "Invalid company name"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] })
      }
      companyField.style.borderBottom = "thick solid red"
    }
  }

  validatorChecker = (stateVar, button) => {
    if(stateVar.emailValid && stateVar.commentValid && stateVar.companyValid && stateVar.nameValid && stateVar.phoneValid){
      this.setState({isValid: true}, this.buttonEnabler(button))
      } else {
        this.setState({isValid: false}, this.buttonDisabler(button))
      
  }}

  buttonEnabler = (button) => {
    button.removeAttribute('disabled')
    button.classList.remove('disabled')
  }

  buttonDisabler = (button) => {
    button.disabled = 'true'
    button.classList.add('disabled')
  }


  componentDidMount() {
    const { embed } = this.props

    window.addEventListener('scroll', this.isScrolled)

    const script = document.createElement('script');
    const pageUrl = window.location.href;
    script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${embed}`
    script.async = true

    script.setAttribute('id', 'activecampaign-script')

    document.body.appendChild(script)



    //-----Edit fetched form-------
    let formElement = document.getElementById("form-container");

    if(this.props.embed === '33'){
      formElement.addEventListener("change", this.formValidator);
      
    }

    //Wait for changes in the form
    const observer = new MutationObserver(() => {


      //Privacy Policy
      let formBox = document.getElementsByClassName("_checkbox-radio");
      formBox = Array.from(formBox);
      for (let item of formBox) {
        if (!item.querySelector('label').textContent.includes('newsletter')) {
          let labelContent = "I accept dol-sensors' <a href='https://www.dol-sensors.com/privacy-policy/' style='text-decoration: underline !important;'> Privacy Policy</a>"
          item.querySelector('label').innerHTML = labelContent;
        }
      }

      //Hiding honeypot element
      let honeyPot = document.getElementsByClassName('_x57317928')[0] 
      if(honeyPot !== undefined) {
        honeyPot.style.display='none';
      }
      
      let inputField = document.getElementsByName('field[1]');
      inputField = Array.from(inputField);
      console.log(inputField)
      if (typeof (inputField) !== 'undefined' && inputField !== null) {
        for (let fieldName of inputField) {
          fieldName.value = 'website';
        }
      }
      //Attach URL to the form field
      let signupField = document.getElementsByName("field[26]");
      let signupArr = [...signupField]
      if(signupArr.length > 0) {
        signupArr[0].value = pageUrl;
      }
      
    });
    //Observe for changes in the form's child list
    observer.observe(formElement, {
      childList: true
    })
    //---------------------------------------------------
  }



  componentWillUnmount() {
    window.removeEventListener('scroll', this.isScrolled)

    const script = document.getElementById('activecampaign-script')

    script.remove()

  }


  isScrolled = () => {
    const { isScrolled } = this.state

    if (window.scrollY > 150 && !isScrolled) {
      this.setState({ isScrolled: true })
    } else if (window.scrollY <= 150 && isScrolled) {
      this.setState({ isScrolled: false })
    }
  }

  scrollTo = () => {
    window.scrollTo(0, this.scrollRef.current.offsetTop)
  }

  render() {
    const {
      embed,
      showScroll,
      scrollButtonText
    } = this.props

    const { isScrolled } = this.state

    return (
      <Wrapper innerRef={this.scrollRef}>
        <Container fluid>
          <Row>
            <Col
              sm={10}
              smOffset={1}
              lg={6}
              lgOffset={3}
              xl={4}
              xlOffset={4}
            >
              <Form className={`_form_${embed}`} id="form-container" onFocus={this.handleClick} ref={this.formRef} />
              {this.state.isValid === false &&
                  <Error>{this.state.errorMsg[0]}</Error>
                }
            </Col>
          </Row>
        </Container>

        {showScroll && (
          <ScrollButton
            visible={isScrolled}
            onClick={this.scrollTo}
          >
            {scrollButtonText}
          </ScrollButton>
        )}
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.div`
  padding: 45px 0;
  background: ${theme.colors.accents.primary};
  color: white;
`

const ScrollButton = styled.button`
  position: fixed;
  bottom: 2em;
  right: 50px;
  z-index: 2;
  font-size: 12px;
  background: ${props => props.theme.colors.highlight};
  color: white;
  padding: 0.5em 1.5em;
  border: none;
  border-radius: 2em;
  text-transform: uppercase;
  opacity: ${props => props.visible ? 1 : 0};
  transition: opacity 0.5s ${easing.easeOutCubic};
  outline: none;

  &:hover {
    cursor: pointer;
  }

  ${media.xs`
    display: none;
  `}
`

const Error = styled.p`
margin: auto;
background-color: #ff00005e;
width: 70%;
text-align: center;
color: aliceblue;
`

const Form = styled.div`
  &&#form-container {
    * {
      font-family: "Work Sans";
      color: white;
      font-size: 16px;
    }

    ._form-content{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    ._field1, ._x29757849 {
      display: none;
    }

    #field[1]{
      display: none !important;
    }

    ._x06147226 {
      width: 40%;
      flex-grow: 2;
    }

    ._x74459413 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field32 {
      width: 40%
      flex-grow: 2;
    }

    
    ._field32 option {
      width: 80%;
    } 

    ._field57 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field57 option {
      width: 80%;
    }

    textarea {
      background: #295F8D;
      color: white !important;
      transition: all 0.2s !important;
    }

    textarea:focus {
      height: 8em !important;
    }

    form {
      width: 100%;
      margin: 0;
      padding: 0;
      background: none !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-title {
      font-weight: 300;
      font-size: 30px;
      line-height: 45px;
    }

    ._form-label {
      font-weight: 500;
    }

    ._form_element {
      margin-bottom: 1.5em;
    }
    
    ._field-wrapper {
      select,
      input {
        background: #295F8D;
        color: white !important;
        border: none;
        border-radius: 0;
        padding: 1em 0.5em;

        &::placeholder {
          color: white;
        }
      }
    }

    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 2em !important;
      padding: 0.5em 1.5em !important;
      transition: all .2s ease-in-out !important;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

    .disabled {
      background-color: grey !important;
    }

    .disabled:hover{
      background-color: grey !important;
    }

    ._form-branding {
      display: none;
    }

    ._form-fieldset > div > span {
      color: red !important;
    }

  }
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/Newsletter/index.js